import React from 'react';
import { ACCOUNT_CREATED_NOTE, PRIVACY_NOTE_LEAD, PRIVACY_NOTE_LINK, PRIVACY_PATH } from '@radevents/shared';

/**
 * Der Satz zur Datenschutzerklärung an jedem Weg, auf dem ein Einmal-Code ein Konto anlegen kann.
 * Steht im Fließtext eines Hinweises und übernimmt dessen Schrift; `withAccount` stellt den Satz
 * voran, dass dabei ein Konto entsteht, wo die Umgebung das nicht schon sagt.
 */
export const PrivacyNote: React.FC<{ withAccount?: boolean }> = ({ withAccount = false }) => (
  <>
    {withAccount && <>{ACCOUNT_CREATED_NOTE} </>}
    {PRIVACY_NOTE_LEAD}{' '}
    {/* Neuer Tab statt Router-Link: wer gerade eine Adresse oder einen Code eintippt, soll den
        Stand nicht verlieren. */}
    <a href={PRIVACY_PATH} target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>
      {PRIVACY_NOTE_LINK}
    </a>.
  </>
);
